var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"empty"},[_c('div',{staticClass:"empty-main"},[_c('img',{staticClass:"empty-img",attrs:{"src":require('../assets/images/empty.png'),"alt":""}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.name))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }